import { render, staticRenderFns } from "./NavigationComponent.vue?vue&type=template&id=4cd6799e&scoped=true&"
import script from "./NavigationComponent.vue?vue&type=script&lang=js&"
export * from "./NavigationComponent.vue?vue&type=script&lang=js&"
import style0 from "./NavigationComponent.vue?vue&type=style&index=0&id=4cd6799e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd6799e",
  null
  
)

export default component.exports